<template>
  <v-app v-if="isLoggedIn">
    <div class="btn">
      <v-snackbar
        v-model="snackbar"
        :right="x === 'right'"
        :timeout="timeout"
        color="red"
        :top="y === 'top'"
      >
        {{ errorMsg }}
        <v-btn color="black" flat @click="snackbar = false">Close</v-btn>
      </v-snackbar>
    </div>
    <v-layout row class="tool-bar-tab" color="primary" v-if="isDataLoaded">
      <v-toolbar class="project mt-2">
        <v-spacer></v-spacer>
        <v-toolbar-items class="hidden-sm-and-down">
          <v-btn flat class="white--text" @click="back()">create project</v-btn>
          <v-btn
            flat
            class="white--text"
            v-if="getProjectType() == 2"
            @click="locationPage()"
          >
            Location
          </v-btn>
          <v-btn flat class="white--text" @click="assignTeamToProject()">
            Assign Team To Project
          </v-btn>
          <v-btn flat class="white--text" @click="goToQuestion()">
            Question
          </v-btn>
          <!-- <v-btn flat v-if="getProjectType() == 2" @click="locationBasedBudgetPage()">Location Budget</v-btn> -->
        </v-toolbar-items>
      </v-toolbar>
    </v-layout>
    <v-layout>
      <v-flex xs12 sm3>
        <v-container grid-list-md>
          <v-card class="grey lighten-3">
            <v-card-title class="project">
              <div>
                <span class="headline">Pre-Survey Questions List</span>
              </div>
            </v-card-title>
            <v-card-text>
              <v-layout class="previous d-block">
                <v-list class="d-block scrollable">
                  <v-list-tile
                    v-for="(element, indexTest) in questionData.questions"
                    :key="indexTest"
                    avatar
                    @click="listData(indexTest)"
                    :class="getClass(indexTest)"
                  >
                    <v-list-tile-action>
                      <!-- <v-icon >star</v-icon> -->
                      <span class="material-icons" color="#11111">list</span>
                    </v-list-tile-action>

                    <v-list-tile-content
                      v-if="getLanguage() == 1 || getLanguage() == 3"
                    >
                      <v-list-tile-title
                        v-text="
                          questionNameForList(element.question, indexTest)
                        "
                      >
                        {{ indexTest }}
                      </v-list-tile-title>
                    </v-list-tile-content>

                    <v-list-tile-content v-else>
                      <v-list-tile-title
                        v-text="
                          questionNameForList(
                            element.question_bangla,
                            indexTest
                          )
                        "
                      >
                        {{ indexTest }}
                      </v-list-tile-title>
                    </v-list-tile-content>

                    <v-list-tile-action>
                      <!-- <v-icon >star</v-icon> -->
                      <span
                        class="material-icons"
                        v-if="indexTest != activeIndex"
                        @click="deleteQuestion(indexTest)"
                        color="#11111"
                      >
                        delete
                      </span>
                    </v-list-tile-action>
                  </v-list-tile>
                </v-list>
              </v-layout>
              <v-spacer></v-spacer>
              <v-layout>
                <v-icon class="icon" @click="addQuestion">add_circle</v-icon>
                <button>Add Question</button>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-container>
      </v-flex>
      <v-flex xs12 sm6>
        <v-container grid-list-md>
          <v-card class="grey lighten-3">
            <v-card-title class="project">
              <div>
                <span class="headline">Pre-Survey Questions Setup</span>
              </div>
            </v-card-title>
            <v-card-text>
              <v-layout>
                <v-icon class="icon" @click="addQuestion">add_circle</v-icon>
                <button>Add Question</button>
              </v-layout>

              <v-form ref="form" lazy-validation>
                <v-layout class="previous d-block">
                  <v-card class="question-layout" justify-space-around>
                    <v-card-title class="project">
                      <span class="headline" for="duration">
                        {{ activeIndex + 1 }}.Question
                      </span>
                    </v-card-title>
                    <v-card-text>
                      <v-container grid-list-md>
                        <v-layout wrap>
                          <v-flex
                            xs12
                            sm6
                            md12
                            v-if="getLanguage() == 1 || getLanguage() == 3"
                          >
                            <v-text-field
                              v-model.lazy="
                                questionData.questions[activeIndex].question
                              "
                              box
                              label="Question English"
                              :rules="[
                                (v) => !!v || 'Question English is required!',
                              ]"
                            ></v-text-field>
                          </v-flex>
                          <v-flex
                            xs12
                            sm6
                            md12
                            v-if="getLanguage() == 2 || getLanguage() == 3"
                          >
                            <v-text-field
                              v-model.lazy="
                                questionData.questions[activeIndex]
                                  .question_bangla
                              "
                              box
                              @keypress="isLetter($event)"
                              label="Question Bangla"
                              :rules="[
                                (v) => !!v || 'Question Bangla is required!',
                              ]"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs12 sm6 md12>
                            <v-select
                              v-model.lazy="
                                questionData.questions[activeIndex]
                                  .ui_category_id
                              "
                              :items="allowedUiCategory()"
                              item-text="name"
                              item-value="id"
                              @change="calculatedPrice($event, activeIndex)"
                              outline
                              label="Choose Question Type"
                              :rules="[
                                (v) => !!v || 'Question Type is required!',
                              ]"
                            ></v-select>
                          </v-flex>
                        </v-layout>

                        <!-- this is dynamic field in question module -->
                        <div
                          v-if="
                            questionData.questions[activeIndex]
                              .ui_category_id == 1
                          "
                        >
                          <v-layout>
                            <v-flex
                              xs6
                              v-if="getLanguage() == 1 || getLanguage() == 3"
                            >
                              <v-radio-group>
                                <v-layout
                                  class="previous"
                                  v-for="(radio, index) in questionData
                                    .questions[activeIndex].radios"
                                  v-bind:key="index"
                                >
                                  <v-radio class="shrink mr-2"></v-radio>
                                  <v-text-field
                                    v-model.lazy="radio.name"
                                    :rules="[
                                      (v) => !!v || 'Option name is required!',
                                    ]"
                                  ></v-text-field>
                                  <v-flex xs2>
                                    <v-icon
                                      v-if="index != 0 && getLanguage() == 1"
                                      @click="deleteOption(activeIndex, index)"
                                    >
                                      clear
                                    </v-icon>
                                    <v-icon
                                      v-if="index != 0 && getLanguage() == 3"
                                      @click="
                                        deleteBothOption(activeIndex, index)
                                      "
                                    >
                                      clear
                                    </v-icon>
                                  </v-flex>
                                </v-layout>
                              </v-radio-group>
                              <v-layout v-if="getLanguage() == 1">
                                <v-icon @click="addOption(activeIndex)">
                                  radio_button_unchecked
                                </v-icon>
                                Add option
                              </v-layout>
                              <v-layout v-if="getLanguage() == 3">
                                <v-icon @click="addBothOption(activeIndex)">
                                  radio_button_unchecked
                                </v-icon>
                                Add option
                              </v-layout>
                            </v-flex>
                            <v-flex
                              xs6
                              v-if="getLanguage() == 2 || getLanguage() == 3"
                            >
                              <v-radio-group>
                                <v-layout
                                  class="previous"
                                  v-for="(
                                    radio_bangla, index_bangla
                                  ) in questionData.questions[activeIndex]
                                    .radios_bangla"
                                  v-bind:key="index_bangla"
                                >
                                  <v-radio class="shrink mr-2"></v-radio>
                                  <v-text-field
                                    v-model.lazy="radio_bangla.name"
                                    :rules="[
                                      (v) =>
                                        !!v ||
                                        'Option Bangla name is required!',
                                    ]"
                                    @keypress="isLetter($event)"
                                  ></v-text-field>
                                  <v-flex xs2>
                                    <v-icon
                                      v-if="
                                        index_bangla != 0 && getLanguage() == 2
                                      "
                                      @click="
                                        deleteOptionBangla(
                                          activeIndex,
                                          index_bangla
                                        )
                                      "
                                    >
                                      clear
                                    </v-icon>
                                  </v-flex>
                                </v-layout>
                              </v-radio-group>
                              <v-layout v-if="getLanguage() == 2">
                                <v-icon @click="addOptionBangla(activeIndex)">
                                  radio_button_unchecked
                                </v-icon>
                                Add অপশন
                              </v-layout>
                            </v-flex>
                          </v-layout>
                        </div>

                        <div
                          v-if="
                            questionData.questions[activeIndex]
                              .ui_category_id == 2
                          "
                          align-center
                        >
                          <v-layout>
                            <v-flex
                              xs6
                              v-if="getLanguage() == 1 || getLanguage() == 3"
                            >
                              <v-layout
                                class="previous"
                                v-for="(checkbox, index) in questionData
                                  .questions[activeIndex].checkboxes"
                                v-bind:key="index"
                              >
                                <v-checkbox class="shrink mr-2"></v-checkbox>
                                <v-text-field
                                  v-model.lazy="checkbox.name"
                                  :rules="[
                                    (v) => !!v || 'Option name is required!',
                                  ]"
                                ></v-text-field>
                                <v-flex xs2>
                                  <v-icon
                                    v-if="index != 0 && getLanguage() == 1"
                                    @click="deleteCheckbox(activeIndex, index)"
                                  >
                                    clear
                                  </v-icon>
                                  <v-icon
                                    v-if="index != 0 && getLanguage() == 3"
                                    @click="
                                      deleteBothCheckbox(activeIndex, index)
                                    "
                                  >
                                    clear
                                  </v-icon>
                                </v-flex>
                              </v-layout>
                              <v-layout v-if="getLanguage() == 1">
                                <v-icon @click="addCheckbox(activeIndex)">
                                  check_box_outline_blank
                                </v-icon>
                                Add option
                              </v-layout>
                              <v-layout v-if="getLanguage() == 3">
                                <v-icon @click="addBothCheckbox(activeIndex)">
                                  check_box_outline_blank
                                </v-icon>
                                Add option
                              </v-layout>
                            </v-flex>
                            <v-flex
                              xs6
                              v-if="getLanguage() == 2 || getLanguage() == 3"
                            >
                              <v-layout
                                class="previous"
                                v-for="(checkbox_bangla, index) in questionData
                                  .questions[activeIndex].checkboxes_bangla"
                                v-bind:key="index"
                              >
                                <v-checkbox class="shrink mr-2"></v-checkbox>
                                <v-text-field
                                  v-model.lazy="checkbox_bangla.name"
                                  :rules="[
                                    (v) =>
                                      !!v || 'Option Bangla name is required!',
                                  ]"
                                  @keypress="isLetter($event)"
                                ></v-text-field>
                                <v-flex xs2>
                                  <v-icon
                                    v-if="index != 0 && getLanguage() == 2"
                                    @click="
                                      deleteCheckboxBangla(activeIndex, index)
                                    "
                                  >
                                    clear
                                  </v-icon>
                                </v-flex>
                              </v-layout>
                              <v-layout v-if="getLanguage() == 2">
                                <v-icon @click="addCheckboxBangla(activeIndex)">
                                  check_box_outline_blank
                                </v-icon>
                                Add অপশন
                              </v-layout>
                            </v-flex>
                          </v-layout>
                        </div>

                        <div
                          v-if="
                            questionData.questions[activeIndex]
                              .ui_category_id == 4
                          "
                          align-center
                        >
                          <v-layout>
                            <v-flex
                              xs6
                              v-if="getLanguage() == 1 || getLanguage() == 3"
                            >
                              <v-layout
                                class="previous"
                                v-for="(dropdown, index) in questionData
                                  .questions[activeIndex].dropdowns"
                                v-bind:key="index"
                              >
                                <v-text-field
                                  v-model.lazy="dropdown.name"
                                  :rules="[
                                    (v) => !!v || 'Option name is required!',
                                  ]"
                                ></v-text-field>
                                <v-flex xs2>
                                  <v-icon
                                    v-if="index != 0 && getLanguage() == 1"
                                    @click="deleteDropDown(activeIndex, index)"
                                  >
                                    clear
                                  </v-icon>
                                  <v-icon
                                    v-if="index != 0 && getLanguage() == 3"
                                    @click="
                                      deleteBothDropDown(activeIndex, index)
                                    "
                                  >
                                    clear
                                  </v-icon>
                                </v-flex>
                              </v-layout>
                              <v-layout v-if="getLanguage() == 1">
                                <v-icon @click="addDropDown(activeIndex)">
                                  radio_button_unchecked
                                </v-icon>
                                Add option
                              </v-layout>
                              <v-layout v-if="getLanguage() == 3">
                                <v-icon @click="addBothDropDown(activeIndex)">
                                  radio_button_unchecked
                                </v-icon>
                                Add option
                              </v-layout>
                            </v-flex>
                            <v-flex
                              xs6
                              v-if="getLanguage() == 2 || getLanguage() == 3"
                            >
                              <v-layout
                                class="previous"
                                v-for="(dropdown_bangla, index) in questionData
                                  .questions[activeIndex].dropdowns_bangla"
                                v-bind:key="index"
                              >
                                <v-text-field
                                  v-model.lazy="dropdown_bangla.name"
                                  :rules="[
                                    (v) =>
                                      !!v || 'Option Bangla name is required!',
                                  ]"
                                  @keypress="isLetter($event)"
                                ></v-text-field>
                                <v-flex xs2>
                                  <v-icon
                                    v-if="index != 0 && getLanguage() == 2"
                                    @click="
                                      deleteDropDownBangla(activeIndex, index)
                                    "
                                  >
                                    clear
                                  </v-icon>
                                </v-flex>
                              </v-layout>
                              <v-layout v-if="getLanguage() == 2">
                                <v-icon @click="addDropDownBangla(activeIndex)">
                                  radio_button_unchecked
                                </v-icon>
                                Add অপশন
                              </v-layout>
                            </v-flex>
                          </v-layout>
                        </div>

                        <div
                          v-if="
                            questionData.questions[activeIndex]
                              .ui_category_id == 14
                          "
                        >
                          <v-layout
                            row
                            v-for="(image, index) in questionData.questions[
                              activeIndex
                            ].images"
                            v-bind:key="index"
                          >
                            <v-flex xs12 sm6>
                              <v-container fluid grid-list-lg>
                                <v-layout row wrap>
                                  <v-flex xs6>
                                    <image-upload
                                      :imageUrl="image.url"
                                      :imageBaseUrl="indexData.quesImageUrl"
                                      @change="
                                        onImageChange(
                                          $event,
                                          activeIndex,
                                          index
                                        )
                                      "
                                      select-text="Select Image"
                                    />
                                  </v-flex>
                                  <v-flex xs4>
                                    <v-text-field
                                      v-model.lazy="image.name"
                                      label="Image name"
                                      :rules="[
                                        (event) =>
                                          imageValidationCheck(
                                            event,
                                            activeIndex,
                                            index
                                          ),
                                        rules.required,
                                      ]"
                                    >
                                      @keypress="isLetterForImage($event)">
                                    </v-text-field>
                                  </v-flex>
                                  <div v-if="index > -1">
                                    <v-icon
                                      @click="deleteImage(activeIndex, index)"
                                      color="black"
                                    >
                                      cancel
                                    </v-icon>
                                  </div>
                                </v-layout>
                              </v-container>
                            </v-flex>
                          </v-layout>
                          <v-layout>
                            <v-flex>
                              <v-btn
                                color="success"
                                class="i_button"
                                @click="addImage(activeIndex)"
                              >
                                Add option
                                <v-icon color="black" right>
                                  add_circle_outline
                                </v-icon>
                              </v-btn>
                            </v-flex>
                          </v-layout>
                        </div>

                        <v-layout
                          v-if="
                            questionData.questions[activeIndex]
                              .ui_category_id == 18
                          "
                          row
                        >
                          <v-icon>Numeric</v-icon>
                          <v-text-field
                            type="number"
                            disabled
                            label="Number"
                          ></v-text-field>
                        </v-layout>

                        <!-- end dynamic field in question module -->
                        <v-divider
                          v-if="
                            questionData.questions[activeIndex]
                              .ui_category_id != ''
                          "
                          class="mt-3"
                        ></v-divider>
                        <v-layout
                          wrap
                          v-if="
                            questionData.questions[activeIndex]
                              .ui_category_id != ''
                          "
                        >
                          <v-flex xs12>
                            <div class="subheader black--text">Logics</div>
                          </v-flex>
                          <v-flex xs12 sm6 md12>
                            <v-layout row>
                              <v-card-text>
                                <v-flex xs12 class="previous">
                                  <v-layout>
                                    <v-flex xs3>
                                      <v-select
                                        v-model.lazy="
                                          questionData.questions[activeIndex]
                                            .logic_set.logic_operator_id
                                        "
                                        :items="filterOperator(activeIndex)"
                                        item-text="name"
                                        item-value="id"
                                        outline
                                        label="Choose operator"
                                        :rules="[
                                          (v) =>
                                            !!v || 'This Field is required!',
                                        ]"
                                      ></v-select>
                                    </v-flex>
                                    <v-flex
                                      xs4
                                      v-if="
                                        questionData.questions[activeIndex]
                                          .ui_category_id == 18
                                      "
                                    >
                                      <v-text-field
                                        type="number"
                                        v-model.lazy="
                                          questionData.questions[activeIndex]
                                            .logic_set.logic_input
                                        "
                                        :rules="[
                                          (v) =>
                                            !!v || 'This Field is required!',
                                        ]"
                                      ></v-text-field>
                                    </v-flex>
                                    <v-flex xs4 v-else>
                                      <v-select
                                        v-model.lazy="
                                          questionData.questions[activeIndex]
                                            .logic_set.logic_input
                                        "
                                        :items="getLogicInputValue(activeIndex)"
                                        item-text="name"
                                        item-value="value"
                                        outline
                                        label="Choose value"
                                        multiple
                                        :rules="[
                                          (v) =>
                                            !!v || 'This Field is required!',
                                        ]"
                                      ></v-select>
                                    </v-flex>
                                  </v-layout>
                                </v-flex>
                              </v-card-text>
                            </v-layout>
                          </v-flex>
                        </v-layout>
                        <!-- start card footer -->
                        <v-divider
                          v-if="questionData.questions[activeIndex].boolean1"
                        ></v-divider>
                        <v-layout
                          v-if="questionData.questions[activeIndex].boolean1"
                          wrap
                        >
                          <v-flex
                            xs12
                            v-if="getLanguage() == 1 || getLanguage() == 3"
                          >
                            <ckeditor
                              :editor="editor"
                              v-model.lazy="
                                questionData.questions[activeIndex].instruction
                              "
                              label="Instruction"
                              :config="editorConfigInstruction"
                            ></ckeditor>
                          </v-flex>
                          <v-flex
                            xs12
                            v-if="getLanguage() == 2 || getLanguage() == 3"
                          >
                            <ckeditor
                              :editor="editor"
                              v-model.lazy="
                                questionData.questions[activeIndex]
                                  .instruction_bangla
                              "
                              label="Instruction Bangla"
                              :config="editorConfigInstructionBangla"
                            ></ckeditor>
                          </v-flex>
                        </v-layout>
                        <v-divider></v-divider>
                        <v-layout
                          v-if="questionData.questions[activeIndex].boolean2"
                          wrap
                        >
                          <v-flex
                            xs12
                            v-if="getLanguage() == 1 || getLanguage() == 3"
                          >
                            <ckeditor
                              :editor="editor"
                              v-model.lazy="
                                questionData.questions[activeIndex].description
                              "
                              :config="editorConfig"
                            ></ckeditor>
                          </v-flex>
                          <v-flex
                            xs12
                            v-if="getLanguage() == 2 || getLanguage() == 3"
                          >
                            <ckeditor
                              :editor="editor"
                              v-model.lazy="
                                questionData.questions[activeIndex]
                                  .description_bangla
                              "
                              label="Description"
                              :config="editorConfig1"
                            ></ckeditor>
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </v-card-text>

                    <v-divider></v-divider>

                    <v-card-title class="pt-1 pb-1">
                      <span class="material-icons" @click="addQuestion">
                        add_circle_outline
                      </span>

                      <v-spacer></v-spacer>

                      <v-menu offset-x>
                        <template v-slot:activator="{ on }">
                          <v-btn icon v-on="on">
                            <v-icon>more_vert</v-icon>
                          </v-btn>
                        </template>

                        <v-list>
                          <v-list-tile
                            v-for="(item, i) in items"
                            :key="i"
                            @click="listItem(activeIndex, i)"
                          >
                            <v-list-tile-title>
                              {{ item.title }}
                            </v-list-tile-title>
                          </v-list-tile>
                        </v-list>
                      </v-menu>
                    </v-card-title>
                  </v-card>
                </v-layout>
              </v-form>
            </v-card-text>
            <v-divider></v-divider>

            <v-card-actions>
              <v-spacer></v-spacer>
              <button class="button" flat @click="back">Back</button>
              <v-btn class="button" flat @click="submit">Save & next</v-btn>
            </v-card-actions>
          </v-card>
        </v-container>
      </v-flex>
      <v-flex xs12 sm3>
        <pre-survey-comment />
      </v-flex>
    </v-layout>
  </v-app>
  <v-layout v-else>
    <Signin class="mt-1"></Signin>
  </v-layout>
</template>

<script>
  import { ImageUpload } from "@/components/index";
  import { mapGetters } from "vuex";
  import ClassicEditor from "ckeditor5-build-classic-base64-upload";
  import PreSurveyComment from "./PreSurveyComment";
  import axios from "axios";
  import api from "../../../api/connectingUrls";

  export default {
    components: {
      ImageUpload,
      PreSurveyComment,
      // draggable,
    },
    data: () => ({
      apiUrl: "pre-survey-question-json",
      editedIndex: -1,
      activeIndex: 0,
      refreshRequest: 0,
      flag: null,
      //star rating
      length: 5,
      rating: 3,
      readonly: true,
      snackbar: false,
      y: "top",
      x: null,
      mode: "multi-line",
      comparison_operators: null,
      timeout: 4000,
      questionData: {
        questions: [
          {
            question: "",
            question_bangla: "",
            ui_category_id: "",
            required_optional: "",
            multiple_answer: "",
            instruction: "",
            instruction_bangla: "",
            description: "",
            description_bangla: "",
            otp_verification: false,
            error_message: "",
            boolean1: false,
            boolean2: false,
            has_logic: false,
            date_time: "date & time",
            logic_set: {
              question_logic_variable: "",
              logic_operator_id: "",
              logic_input: "",
            },
            radios: [
              {
                name: "option1",
                value: 1,
              },
            ],
            radios_bangla: [
              {
                name: "অপশন১",
                value: 1,
              },
            ],
            checkboxes: [
              {
                name: "option1",
                value: 1,
              },
            ],
            checkboxes_bangla: [
              {
                name: "অপশন১",
                value: 1,
              },
            ],
            dropdowns: [
              {
                name: "option1",
                value: 1,
              },
            ],
            dropdowns_bangla: [
              {
                name: "অপশন১",
                value: 1,
              },
            ],
            images: [
              {
                url: "",
                id: "",
                value: 1,
                name: "",
              },
            ],
          },
        ],
        project_id: "",
        pre_ui_category_price: [],
        pre_total_category_price: 0,
      },
      defaultItem: {
        question: "",
        question_bangla: "",
        question_type_id: "",
        required_optional: "",
        instruction: "",
        instruction_bangla: "",
        description: "",
        description_bangla: "",
        multiple_answer: "",
      },
      items: [{ title: "Instruction" }, { title: "description" }],
      editor: ClassicEditor,
      editorData: "<p>Content of the editor.</p>",
      editorConfig: {
        placeholder: "Type the description here!",
        height: 300,
        minimumCharacters: 5,
      },
      editorConfig1: {
        placeholder: "Type the description Bangla here!",
        height: 300,
        minimumCharacters: 5,
      },
      editorConfigInstruction: {
        placeholder: "Type the instruction here!",
        height: 300,
        minimumCharacters: 5,
      },
      editorConfigInstructionBangla: {
        placeholder: "Type the Bangla instruction here!",
        height: 300,
        minimumCharacters: 5,
      },

      QuestSubmitData: {
        data: [],
      },
      rules: {
        required: (v) => !!v || "this field is required",
      },
    }),

    computed: {
      ...mapGetters([
        "isLoggedIn",
        "indexData",
        "error",
        "statusCode",
        "errorMsg",
        "projectId",
      ]),
      binding() {
        const binding = {};

        if (this.$vuetify.breakpoint.mdAndUp) binding.column = true;

        return binding;
      },

      isDataLoaded() {
        return this.setQuestionData();
      },
    },

    created() {
      this.initialize();
    },

    methods: {
      initialize() {
        var project_id_modify = JSON.parse(
          localStorage.getItem("project_id_modify")
        );

        // console.log(project_id);
        this.questionData.project_id = project_id_modify;
        this.$store.dispatch("indexData", [this.apiUrl, project_id_modify]);
        if (this.indexData.project_data) {
          if (this.indexData.project_data.pre_survey_question_json !== null) {
            var questions_data_json = JSON.parse(
              this.indexData.project_data.pre_survey_question_json
            );
            this.questionData = questions_data_json;
            // console.log(this.questionData);
          }
          this.comparison_operators = this.indexData.operators;
        }
      },

      getClass(indexTest) {
        if (indexTest == this.activeIndex) {
          return "m-b-1 list-color-active";
        } else {
          return "m-b-1";
        }
      },

      getGroupName(group_index) {
        return "Logic group - " + (group_index + 1);
      },

      getLogicInputValue(activeIndex) {
        var ui_category =
          this.questionData.questions[activeIndex].ui_category_id;

        if (ui_category == 1) {
          if (this.getLanguage() == 2) {
            return this.questionData.questions[activeIndex].radios_bangla;
          }
          return this.questionData.questions[activeIndex].radios;
        } else if (ui_category == 2) {
          if (this.getLanguage() == 2) {
            return this.questionData.questions[activeIndex].checkboxes_bangla;
          }
          return this.questionData.questions[activeIndex].checkboxes;
        } else if (ui_category == 4) {
          if (this.getLanguage() == 2) {
            return this.questionData.questions[activeIndex].dropdowns_bangla;
          }
          return this.questionData.questions[activeIndex].dropdowns;
        } else {
          // console.log(this.questionData.questions[activeIndex].images);
          return this.questionData.questions[activeIndex].images;
        }
      },

      checkInputType(ui_category_id, activeIndex) {
        if (
          ui_category_id == 18 ||
          ui_category_id == 7 ||
          ui_category_id == 8 ||
          ui_category_id == 6
        ) {
          this.questionData.questions[
            activeIndex
          ].logic_set.logic_input_ui_type = "input";
          return true;
        }
        this.questionData.questions[activeIndex].logic_set.logic_input_ui_type =
          "select";
        return false;
        // console.log(question_type_data);
      },

      filterOperator(activeIndex) {
        // console.log(event);
        var filterValue = [];
        var ui_category_id =
          this.questionData.questions[activeIndex].ui_category_id;
        if (this.indexData) {
          if (ui_category_id == 18) {
            this.comparison_operators.forEach((element) => {
              if (element.id != 6 && element.id != 7) {
                filterValue.push(element);
              }
            });
          } else {
            this.comparison_operators.forEach((element) => {
              if (element.id == 6 || element.id == 7) {
                filterValue.push(element);
              }
            });
          }
        }

        return filterValue;
        //  console.log(this.questionData.questions[activeIndex]);
      },

      allowedUiCategory() {
        var allowedUiCategory = [];
        if (this.indexData.uiCategories) {
          this.indexData.uiCategories.forEach((element) => {
            if (
              element.id == 1 ||
              element.id == 4 ||
              element.id == 14 ||
              element.id == 18
            ) {
              allowedUiCategory.push(element);
            }
          });
          return allowedUiCategory;
        }
      },

      getLanguage() {
        if (this.indexData.project_data) {
          return this.indexData.project_data.project_language;
        } else {
          return "";
        }
      },

      getProjectType() {
        if (this.indexData.project_data) {
          if (this.indexData.project_data.project_type_id) {
            return this.indexData.project_data.project_type_id;
          }
        }
        return false;
      },

      setQuestionData() {
        // this.questionData.project_id = project_id;
        if (this.refreshRequest == "0") {
          this.$store.dispatch("indexData", [
            this.apiUrl,
            this.questionData.project_id,
          ]);
          this.refreshRequest = 1;
        }
        if (this.indexData.project_data) {
          if (this.indexData.project_data.pre_survey_question_json != null) {
            var questions_data_json = JSON.parse(
              this.indexData.project_data.pre_survey_question_json
            );

            this.questionData = questions_data_json;
            // console.log(this.questionData);
          }
          this.comparison_operators = this.indexData.operators;
        }
        return true;
      },

      listData(indexTest) {
        this.activeIndex = indexTest;
        // console.log(this.questionData.questions[indexTest]);
      },

      questionNameForList(questionName, IndexOfQuestion) {
        return "Q" + (IndexOfQuestion + 1) + " " + questionName;
      },

      addQuestion() {
        this.questionData.questions.push({
          question: "",
          question_bangla: "",
          ui_category_id: "",
          required_optional: "",
          multiple_answer: "",
          instruction: "",
          instruction_bangla: "",
          description: "",
          description_bangla: "",
          otp_verification: false,
          error_message: "",
          boolean1: false,
          boolean2: false,
          has_logic: false,
          date_time: "date & time",
          logic_set: {
            question_logic_variable: "",
            logic_operator_id: "",
            logic_input: "",
          },
          radios: [
            {
              name: "option1",
              value: 1,
            },
          ],
          radios_bangla: [
            {
              name: "অপশন১",
              value: 1,
            },
          ],
          checkboxes: [
            {
              name: "option1",
              value: 1,
            },
          ],
          checkboxes_bangla: [
            {
              name: "অপশন১",
              value: 1,
            },
          ],
          dropdowns: [
            {
              name: "option1",
              value: 1,
            },
          ],
          dropdowns_bangla: [
            {
              name: "অপশন১",
              value: 1,
            },
          ],
          images: [
            {
              url: "",
              id: "",
              value: 1,
              name: "",
            },
          ],
        });
        this.activeIndex = this.questionData.questions.length - 1;
      },
      // calculate price with question type
      calculatedPrice(event, counter) {
        // console.log(this.questionData);
        this.questionData.pre_ui_category_price[counter] =
          this.indexData.uiCategories[event - 1].price;
        this.questionData.questions[counter].logic_set.question_logic_variable =
          counter;
      },
      isLetter(e) {
        let char = String.fromCharCode(e.keyCode); // Get the character
        if (!/^[A-Za-z]+$/.test(char)) return true;
        // Match with regex
        else e.preventDefault(); // If not match, don't add to input text
      },
      isLetterForImage(e) {
        let char = String.fromCharCode(e.keyCode); // Get the character
        if (/^[_A-Za-z0-9]+$/.test(char)) return true;
        // Match with regex
        else e.preventDefault(); // If not match, don't add to input text
      },
      imageValidationCheck(event, activeIndex, index) {
        var match_index = true;
        this.questionData.questions[activeIndex].images.forEach(
          (element, i) => {
            if (event === element.name && i !== index) {
              match_index = false;
            }
          }
        );
        if (!match_index) {
          return `Image name must be unique for a question`;
        } else {
          return match_index;
        }
      },
      deleteQuestion(counter) {
        this.questionData.questions.splice(counter, 1);
        this.questionData.pre_ui_category_price.splice(counter, 1);
      },
      addOption(counter) {
        var radios_length =
          this.questionData.questions[counter].radios.length + 1;
        this.questionData.questions[counter].radios.push({
          name: "option",
          value: radios_length,
        });
      },
      deleteOption(counter, index) {
        if (this.validateOptionDelete(counter)) {
          alert(
            "You can't delete this options. Because you use these options as logic in next question"
          );
        } else {
          this.questionData.questions[counter].radios.splice(index, 1);

          this.questionData.questions[counter].radios.forEach((element, i) => {
            this.questionData.questions[counter].radios[i].value = i + 1;
          });
        }
      },

      addOptionBangla(counter) {
        var radios_length =
          this.questionData.questions[counter].radios_bangla.length + 1;
        this.questionData.questions[counter].radios_bangla.push({
          name: "অপশন",
          value: radios_length,
        });
      },
      deleteOptionBangla(counter, index) {
        if (this.validateOptionDelete(counter)) {
          alert(
            "You can't delete this options. Because you use these options as logic in next question"
          );
        } else {
          this.questionData.questions[counter].radios_bangla.splice(index, 1);

          this.questionData.questions[counter].radios_bangla.forEach(
            (element, i) => {
              this.questionData.questions[counter].radios_bangla[i].value =
                i + 1;
            }
          );
        }
      },
      addBothOption(counter) {
        var radios_length =
          this.questionData.questions[counter].radios.length + 1;
        this.questionData.questions[counter].radios.push({
          name: "option",
          value: radios_length,
        });
        this.questionData.questions[counter].radios_bangla.push({
          name: "অপশন",
          value: radios_length,
        });
      },
      validateOptionDelete(counter) {
        var counter_variable =
          this.questionData.questions[counter].question_variable;
        var isMatch = false;
        for (var i = counter + 1; i < this.questionData.questions.length; i++) {
          // console.log(this.questionData.questions[i].logic_variables);
          this.questionData.questions[i].logic_variables.forEach((element) => {
            if (element.var_name == counter_variable) {
              // console.log("match");
              isMatch = true;
            }
          });
        }
        return isMatch;
      },

      deleteBothOption(counter, index) {
        // console.log(this.questionData.questions[counter].radios_bangla);
        if (this.validateOptionDelete(counter)) {
          alert(
            "You can't delete this options. Because you use these options as logic in next question"
          );
        } else {
          this.questionData.questions[counter].radios.splice(index, 1);
          this.questionData.questions[counter].radios_bangla.splice(index, 1);

          this.questionData.questions[counter].radios_bangla.forEach(
            (element, i) => {
              this.questionData.questions[counter].radios[i].value = i + 1;
              this.questionData.questions[counter].radios_bangla[i].value =
                i + 1;
            }
          );
        }
      },

      addCheckbox(counter) {
        var checkboxes_length =
          this.questionData.questions[counter].checkboxes.length + 1;
        this.questionData.questions[counter].checkboxes.push({
          name: "option",
          value: checkboxes_length,
        });
      },
      deleteCheckbox(counter, index) {
        if (this.validateOptionDelete(counter)) {
          alert(
            "You can't delete this options. Because you use these options as logic in next question"
          );
        } else {
          this.questionData.questions[counter].checkboxes.splice(index, 1);

          this.questionData.questions[counter].checkboxes.forEach(
            (element, i) => {
              this.questionData.questions[counter].checkboxes[i].value = i + 1;
            }
          );
        }
      },

      addCheckboxBangla(counter) {
        var checkboxes_length =
          this.questionData.questions[counter].checkboxes_bangla.length + 1;
        this.questionData.questions[counter].checkboxes_bangla.push({
          name: "অপশন",
          value: checkboxes_length,
        });
      },

      deleteCheckboxBangla(counter, index) {
        if (this.validateOptionDelete(counter)) {
          alert(
            "You can't delete this options. Because you use these options as logic in next question"
          );
        } else {
          this.questionData.questions[counter].checkboxes_bangla.splice(
            index,
            1
          );

          this.questionData.questions[counter].checkboxes_bangla.forEach(
            (element, i) => {
              this.questionData.questions[counter].checkboxes_bangla[i].value =
                i + 1;
            }
          );
        }
      },

      addBothCheckbox(counter) {
        var checkboxes_length =
          this.questionData.questions[counter].checkboxes_bangla.length + 1;
        this.questionData.questions[counter].checkboxes.push({
          name: "option",
          value: checkboxes_length,
        });
        this.questionData.questions[counter].checkboxes_bangla.push({
          name: "অপশন",
          value: checkboxes_length,
        });
      },

      deleteBothCheckbox(counter, index) {
        if (this.validateOptionDelete(counter)) {
          alert(
            "You can't delete this options. Because you use these options as logic in next question"
          );
        } else {
          this.questionData.questions[counter].checkboxes.splice(index, 1);
          this.questionData.questions[counter].checkboxes_bangla.splice(
            index,
            1
          );

          this.questionData.questions[counter].checkboxes_bangla.forEach(
            (element, i) => {
              this.questionData.questions[counter].checkboxes[i].value = i + 1;
              this.questionData.questions[counter].checkboxes_bangla[i].value =
                i + 1;
            }
          );
        }
      },

      addDropDown(counter) {
        var dropdowns_length =
          this.questionData.questions[counter].dropdowns.length + 1;
        this.questionData.questions[counter].dropdowns.push({
          name: "option",
          value: dropdowns_length,
        });
      },

      deleteDropDown(counter, index) {
        if (this.validateOptionDelete(counter)) {
          alert(
            "You can't delete this options. Because you use these options as logic in next question"
          );
        } else {
          this.questionData.questions[counter].dropdowns.splice(index, 1);

          this.questionData.questions[counter].dropdowns.forEach(
            (element, i) => {
              this.questionData.questions[counter].dropdowns[i].value = i + 1;
            }
          );
        }
      },

      addDropDownBangla(counter) {
        var dropdowns_length =
          this.questionData.questions[counter].dropdowns_bangla.length + 1;
        this.questionData.questions[counter].dropdowns_bangla.push({
          name: "অপশন",
          value: dropdowns_length,
        });
      },
      deleteDropDownBangla(counter, index) {
        if (this.validateOptionDelete(counter)) {
          alert(
            "You can't delete this options. Because you use these options as logic in next question"
          );
        } else {
          this.questionData.questions[counter].dropdowns_bangla.splice(
            index,
            1
          );

          this.questionData.questions[counter].dropdowns_bangla.forEach(
            (element, i) => {
              this.questionData.questions[counter].dropdowns_bangla[i].value =
                i + 1;
            }
          );
        }
      },
      addBothDropDown(counter) {
        var dropdowns_length =
          this.questionData.questions[counter].dropdowns.length + 1;
        this.questionData.questions[counter].dropdowns.push({
          name: "option",
          value: dropdowns_length,
        });
        this.questionData.questions[counter].dropdowns_bangla.push({
          name: "অপশন",
          value: dropdowns_length,
        });
      },
      deleteBothDropDown(counter, index) {
        if (this.validateOptionDelete(counter)) {
          alert(
            "You can't delete this options. Because you use these options as logic in next question"
          );
        } else {
          this.questionData.questions[counter].dropdowns_bangla.splice(
            index,
            1
          );
          this.questionData.questions[counter].dropdowns.splice(index, 1);

          this.questionData.questions[counter].dropdowns_bangla.forEach(
            (element, i) => {
              this.questionData.questions[counter].dropdowns[i].value = i + 1;
              this.questionData.questions[counter].dropdowns_bangla[i].value =
                i + 1;
            }
          );
        }
      },
      addImage(counter) {
        var image_length =
          this.questionData.questions[counter].images.length + 1;
        this.questionData.questions[counter].images.push({
          url: "",
          id: "",
          value: image_length,
          name: "",
        });
      },
      deleteImage(counter, index) {
        const token = window.localStorage.getItem("datadash_token");
        if (this.questionData.questions[counter].images[index].id) {
          if (token != null) {
            axios
              .post(
                `${api.rootUrl}/${"pre-survey-image-delete"}`,
                this.questionData.questions[counter].images[index],
                {
                  headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                  },
                }
              )
              .then((response) => {
                if (response.data.data.success == 1) {
                  this.questionData.questions[counter].images.splice(index, 1);
                }
              });
          }
        } else {
          this.questionData.questions[counter].images.splice(index, 1);
        }
      },

      listItem(counter, index) {
        // console.log(counter,index)
        if (index == 0) {
          this.questionData.questions[counter].instruction = "";
          this.questionData.questions[counter].boolean1 =
            !this.questionData.questions[counter].boolean1;
        } else {
          this.questionData.questions[counter].description = "";
          this.questionData.questions[counter].boolean2 =
            !this.questionData.questions[counter].boolean2;
        }
      },

      onImageChange(file, counter, index) {
        var reader = new FileReader();
        reader.addEventListener(
          "load",
          function () {
            // convert image file to base64 string
            let str = reader.result;
            let res = str.split(",");
            // console.log(res);
            this.questionData.questions[counter].images[index].url = res[1];
          }.bind(this),
          false
        );

        if (file) {
          reader.readAsDataURL(file);
        }
        setTimeout(() => {
          this.uploadOptionImage(counter, index);
        }, 600);
        // console.log(file);
      },

      uploadOptionImage(counter, index) {
        if (
          typeof this.questionData.questions[counter].images[index].id ===
          "undefined"
        ) {
          this.questionData.questions[counter].images[index].id = null;
        }
        var imageData = {
          imageInfo: this.questionData.questions[counter].images[index],
          project_id: this.indexData.project_data.id,
        };
        // console.log(imageData);
        if (this.questionData.questions[counter].images[index].url) {
          try {
            const token = window.localStorage.getItem("datadash_token");
            if (token != null) {
              axios
                .post(`${api.rootUrl}/${"pre-option-image"}`, imageData, {
                  headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                  },
                })
                .then((response) => {
                  // console.log(response);
                  if (response.data.data.datas.id != "") {
                    this.questionData.questions[counter].images[index].id =
                      response.data.data.datas.id;
                    this.questionData.questions[counter].images[index].url =
                      response.data.data.datas.url;
                  }
                });
            }
          } catch (error) {
            this.indexData.error = error;
            this.x = "right";
            this.snackbar = true;
            this.close();
          }
        }
        // console.log(this.questionData.questions[counter].images);
      },
      // calculate sum of total question price
      totalCategoryPrice() {
        var i;
        this.questionData.pre_total_category_price = 0;
        for (i = 0; i < this.questionData.pre_ui_category_price.length; i++) {
          this.questionData.pre_total_category_price +=
            this.questionData.pre_ui_category_price[i];
        }
      },

      back() {
        var project_id = JSON.parse(localStorage.getItem("project_id_modify"));
        if (this.indexData.project_data.project_type_id == 2) {
          this.$store.dispatch("indexDataAndRout", [
            "response-location",
            project_id,
            "/edit-address",
          ]);
        } else {
          this.$store.dispatch("indexDataAndRout", [
            "project-info",
            project_id,
            "/edit-project",
          ]);
        }
      },
      // go to assign team to project page
      assignTeamToProject() {
        var project_id = JSON.parse(localStorage.getItem("project_id_modify"));
        this.$store.dispatch("indexDataAndRout", [
          "project-dasher-category",
          project_id,
          "/edit-assign-teams-to-Project",
        ]);
      },
      // go to question page
      goToQuestion() {
        var project_id = JSON.parse(localStorage.getItem("project_id_modify"));
        this.$store.dispatch("indexDataAndRout", [
          "question-json",
          project_id,
          "/edit-dynamic-question",
        ]);
      },
      // go to location page
      locationPage() {
        var project_id = JSON.parse(localStorage.getItem("project_id_modify"));

        this.$store.dispatch("indexDataAndRout", [
          "response-location",
          project_id,
          "/edit-address",
        ]);
      },
      // go to location based budget page
      locationBasedBudgetPage() {
        var project_id = JSON.parse(localStorage.getItem("project_id_modify"));

        this.$store.dispatch("indexDataAndRout", [
          "project-info",
          project_id,
          "/edit-budget2",
        ]);

        // router.push("/budget2");
      },
      // go to budget page
      budgetPage() {
        var project_id = JSON.parse(localStorage.getItem("project_id_modify"));
        this.$store.dispatch("indexDataAndRout", [
          "project-info",
          project_id,
          "/edit-budget",
        ]);
      },
      close() {
        this.dialog = false;
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem);
          this.editedIndex = -1;
        }, 300);
      },
      // submit data to server
      submit() {
        if (this.$refs.form.validate() == true) {
          this.totalCategoryPrice();
          this.QuestSubmitData.data = this.questionData;
          // console.log(this.QuestSubmitData);
          this.$store.dispatch("storeOrUpdatePreSurveyQuestionModify", [
            "pre-survey-question-modify",
            this.QuestSubmitData,
          ]);
          localStorage.setItem("questionObject", null);
          this.x = "right";
          this.snackbar = true;
          this.close();
        }
      },
    },
  };
</script>
<style>
  .ck.ck-editor__editable:not(.ck-editor__nested-editable) {
    border-radius: 0;
    min-height: 100px;
  }
  .ck-content {
    min-height: 100px;
  }
  .question-layout {
    min-width: 500px;
  }
</style>
<style scoped>
  .icon {
    background: #ff2e2e;
    color: aliceblue;
    cursor: pointer;
    border-radius: none;
    margin: 10px;
  }

  .delete {
    color: #3f51b5;
    cursor: pointer;
  }
  span {
    width: 30px;
    cursor: pointer;
  }
  .button {
    font-size: 16px;
    background: #ff2e2e;
    padding: 0.4rem 1.3rem;
    text-align: center;
    border: none;
    cursor: pointer;
    border-radius: 4px;
    margin: 10px;
    color: white;
  }
  .i_button {
    font-size: 14px;
    cursor: pointer;
    border-radius: 6px;
    text-transform: none !important;
  }
  .headline {
    color: white;
  }
  .project {
    background: #ff2e2e;
  }

  .list-color-active {
    background: #ff2e2e;
    border-radius: 5px;
    margin-bottom: 2px;
    color: white;
  }
  .tool-bar-tab {
    background: white;
    margin-top: 2px;
  }
  .scrollable{
  max-height:500px;/* or any height you want */
  min-height:50px;/* or any height you want */
  overflow-y:auto
}
</style>
